import { Spinner, useRouter, useSession } from '@khaddi/ui';
import { useEffect, type ReactNode } from 'react';

/** Sends guests to login and brings them back to the screen they asked for. */
export const RequireAuth = ({ children }: { children: ReactNode }) => {
  const { user, restoring } = useSession();
  const { route, navigate } = useRouter();
  const mustLogin = !restoring && !user;

  useEffect(() => {
    if (mustLogin) navigate(`/login?next=${encodeURIComponent(route.path)}`, { replace: true });
  }, [mustLogin, navigate, route.path]);

  if (!user) return <Spinner />;
  return <>{children}</>;
};
